import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

export const Instrument: ImportTemplateField[] = [
  {
    toField: "instrumentKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentType",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentClass",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "round",
    fromField: "",
    dataType: DataType.integer,
    required: true,
  },
];
